import { TabItem } from '@hakimo-ui/shared/ui-base';
import { TabItemId } from './types';

export const tabItems: TabItem<TabItemId>[] = [
  {
    id: 'cameras',
    name: 'Cameras',
  },
];
